import { useState } from 'react'
import { useMutation } from '@apollo/client'
import { Modal } from '../modal'
import {  GQL_MODELS } from '../../shared/Services/Graphql/querys'
import { MUTATION_UPDATEBRAND } from '../../shared/Services/Graphql/Graphql'

export const UpdateBrand = (props: any) => {
    const [open, setOpen] = useState(false)
    const [title, setTitle] = useState(props.title)
    const [description, setDescription] = useState(props.description)

    const [update] = useMutation(MUTATION_UPDATEBRAND, {
        refetchQueries: [{ query: GQL_MODELS }],        onCompleted: () => {
            setOpen(false)
            window.location.reload()
        }
    })

    function updateBrand() {
        update({
            variables: {
                id: props.id,
                data: {
                    title: title,
                    description: description,
                }
            }
        }).then((res) => {
            if (res.data) {
                console.log(res.data)
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    return (
        <>
            <div className="button button_model" onClick={() => setOpen(!open)}>
                <p>Atualizar slogan</p>
            </div>
            <Modal open={open} setOpen={setOpen} >
                <input
                    placeholder='Título da Marca'
                    type="text"
                    value={title}
                    onChange={(v) => setTitle(v.target.value)}
                    style={{
                        padding: "0.5em 0.8em",
                        marginBottom: "1em",
                        border: "1px solid #ccc",
                    }}
                />
                <input
                    placeholder='Descrição do Título da Marca'
                    type="text"
                    value={description}
                    onChange={(v) => setDescription(v.target.value)}
                    style={{
                        padding: "0.5em 0.8em",
                        marginBottom: "1em",
                        border: "1px solid #ccc",
                    }}
                />
                <div className="button" onClick={() => updateBrand()}> Atualizar </div>
            </Modal>
        </>
    )
}
